import React from 'react'

const Benefits = () => {
  return (
    <div>Benefits</div>
  )
}

export default Benefits